//----- Component --------------------------------------------------------/
// Developer :  Daiana Curcio
// Creation Date :12/02/2025
// Version : 1
// Description : Edicion de reguladores.
//
//------Changes --------------------------------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/
import React, { useState, useEffect } from "react";
import { UrlApi } from "../../../services/apirest";
import {
  Container,
  Typography,
  Grid,
  Box,
  TextField,
  IconButton,
  Button,
  Autocomplete,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { grey } from "@mui/material/colors";
import Notify from "../../Notify";
import Alerta from "../../Alerta";
import { logEventos } from "../../../services/services";

function EditarReg(props) {
  const [datosRegulador, setDatosRegulador] = useState(props.datos);
  const [disBtn, setDisBtn] = useState(false);
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [notificacion, setNotificacion] = useState(false); //define si se muestra o no una notificación (snackbar)
  const [error, setError] = useState(null); //guardará el error que lance la api (si existe)
  const [mensajeAlerta, setMensajeAlerta] = useState(""); //mensaje que contendrá el componente "alerta"
  const [finalizar, setFinalizar] = useState(); //finalizar === 1 lo manda como prop el componente "notify" e indica que la transaccion ha finalizado y debe ejecutarse la funcion para cerrar
  const [severityAlerta, setSeverityAlerta] = useState(""); //define severidad de la alerta (success error o warning)
  const [severitySnack, setSeveritySnack] = useState(""); //define severidad del snackbar (notificación)

  useEffect(() => {
    setDatosRegulador({
      ...props.datos,
    });
  }, [props.datos]);

  const handleClose = () => {
    return props.editar(false), props.tabla(true), props.actualizar(1);
  };

  //*----------------------  OBTENER -----------------------------*//
  const [presionEntrada, setPresionEntrada] = useState();
  const [presionEntradaSeleccionada, setPresionEntradaSeleccionada] =
    useState("");

  const obtenerPresionEntrada = () => {
    fetch(UrlApi + "/reguladores_presion_eys")
      .then((data) => data.json())
      .then((data) => setPresionEntrada(data));
  };
  useEffect(() => {
    obtenerPresionEntrada();
  }, []);

  const [presionSalida, setPresionSalida] = useState();
  const [presionSalidaSeleccionada, setPresionSalidaSeleccionada] =
    useState("");

  const obtenerPresionSalida = () => {
    fetch(UrlApi + "/reguladores_presion_eys")
      .then((data) => data.json())
      .then((data) => setPresionSalida(data));
  };
  useEffect(() => {
    obtenerPresionSalida();
  }, []);

  const [caudal, setCaudal] = useState();
  const [caudalSeleccionado, setCaudalSeleccionado] = useState("");

  const obtenerCaudal = () => {
    fetch(UrlApi + "/reguladores_caudal")
      .then((data) => data.json())
      .then((data) => setCaudal(data));
  };
  useEffect(() => {
    obtenerCaudal();
  }, []);

  const [sucursal, setSucursal] = useState();
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState("");

  const obtenerSucursal = () => {
    fetch(UrlApi + "/sucursales")
      .then((data) => data.json())
      .then((data) => setSucursal(data));
  };
  useEffect(() => {
    obtenerSucursal();
  }, []);

  const [estado, setEstado] = useState();

  const obtenerEstado = () => {
    fetch(UrlApi + "/desplegables/reguladoresStock")
      .then((data) => data.json())
      .then((data) => setEstado(data));
  };
  useEffect(() => {
    obtenerEstado();
  }, []);

  const [marca, setMarca] = useState([]);
  const [marcaSeleccionada, setMarcaSeleccionada] = useState(null);

  const obtenerMarca = () => {
    fetch(UrlApi + "/reguladores_marcas/activos")
      .then((data) => data.json())
      .then((data) => setMarca(data));
  };
  useEffect(() => {
    obtenerMarca();
  }, []);

  const [modelo, setModelo] = useState([]);
  const [modeloSeleccionado, setModeloSeleccionado] = useState(null);

  const obtenerModelo = (id_marca) => {
    fetch(`${UrlApi}/reguladores_marcas/modelosXmarcasActivas/${id_marca}`)
      .then((res) => res.json())
      .then((data) => setModelo(data))
      .catch((err) => console.error("Error obteniendo modelos", err));
  };

  useEffect(() => {
    setModelo([]); // Limpia modelos al cambiar la marca
    setModeloSeleccionado(null);

    if (marcaSeleccionada?.id_marca) {
      obtenerModelo(marcaSeleccionada.id_marca);
    }
  }, [marcaSeleccionada]);

  // Asegurar que `marcaSeleccionada` y `modeloSeleccionado` se inicialicen si ya hay datos en `datosRegulador`
  useEffect(() => {
    if (datosRegulador.marca && marca.length > 0) {
      setMarcaSeleccionada(
        marca.find((m) => m.id_marca === datosRegulador.marca) || null
      );
    }
  }, [marca, datosRegulador.marca]);

  useEffect(() => {
    if (datosRegulador.modelo && modelo.length > 0) {
      setModeloSeleccionado(
        modelo.find((m) => m.id_modelo === datosRegulador.modelo) || null
      );
    }
  }, [modelo, datosRegulador.modelo]);

  // console.log("MARCA", marca);
  // console.log("MARCA SELEC", marcaSeleccionada);
  // console.log("MODELO", modelo);
  // console.log("MODELO SELEC", modeloSeleccionado);

  //*--------------------------------------------------*//

  //Funcion para guardar
  const guardarEditar = async (e) => {
    logEventos(
      "Guardar edición del registro",
      "Administracion Reguladores",
      "Se guardo la edición del registro",
      localStorage.getItem("user")
    );
    setDisBtn(true);
    e.preventDefault();
    const response = await fetch(
      UrlApi + "/reguladores_abm/" + datosRegulador.id_regulador,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          nro_serie: datosRegulador.nro_serie,
          marca: marcaSeleccionada.id_marca,
          modelo: modeloSeleccionado.id_modelo,
          presion_entrada: presionEntradaSeleccionada.id_presion,
          presion_salida: presionSalidaSeleccionada.id_presion,
          caudal: caudalSeleccionado.id_caudal,
          sucursal: sucursalSeleccionada.id,
          año_fabricacion: datosRegulador.año_fabricacion,
          estado: datosRegulador.estado,
          usuario: localStorage.getItem("user"),
        }),
      }
    );
    if (response.ok === false) {
      console.log("ERROR EN API");
      const error = response && response.json();
      setError(error);
      setSeverityAlerta("error");
      setMensajeAlerta("Inconvenientes con la API. No se pudo guardar. ");
    } else {
      console.log("Conexión con api OK");
      try {
        //Parseo respuesta de la api a json()
        const json = await response.json();
        //si api me devuelve lo q le puse en message
        if (json.message) {
          //Si ese mensaje es "OK"
          if (json.message === "OK") {
            console.log("Guardado Satisfactoriamente");
            setNotificacion(true);
            setOpenSnack(true);
            setColorMensaje("#D4EFDF");
            setMensaje("Guardado");
            setSeveritySnack("success");
          } else {
            console.log("res en api incorrecto. Revisar que sea 'OK'");
            setNotificacion(true);
            setOpenSnack(true);
            setColorMensaje("#D4EFDF");
            setSeveritySnack("error");
            setMensaje("Registro Guardado. REVISAR RESPUESTA DE API (E_S)");
          }
        } else if (json.sqlMessage) {
          json && setError(json);
          console.log(json);
          setMensajeAlerta(
            "SQL erróneo (" + json.code + " Errno: " + json.errno + " )"
          );
        } else {
          setMensajeAlerta("ERROR DESCONOCIDO.");
        }
      } catch (error) {
        if (error.toString().includes("is not valid JSON")) {
          console.log(
            "Guardado. Advertencia: Actualizar respuesta de api. JSON invalido."
          );
          setNotificacion(true);
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("Guardado");
          setSeveritySnack("success");
        } else {
          setMensajeAlerta("ERROR DESCONOCIDO.");
        }
      }
    }
    handleClose();
  };

  //funcion para almacenar
  const almacenar = (e) => {
    setDatosRegulador({
      ...datosRegulador,
      [e.target.name]: e.target.value === "" ? null : e.target.value,
    });
  };

  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };

  const size = "small";

  return (
    <div>
      <br></br>
      <Container>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container backgroundColor="#1F618D" p={1.5}>
            <Grid item xs={2}>
              <IconButton onClick={handleClose}>
                <ArrowBackIcon sx={{ color: grey[50] }} />
              </IconButton>
            </Grid>

            <Grid
              item
              xs={8}
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Typography variant="h5" color="#ffffff">
                Editar Regulador
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <form onSubmit={guardarEditar} autoComplete="off">
          <Box
            backgroundColor="#F4F6F6"
            mt={2}
            p={3}
            border={0.5}
            borderColor={"#ABB2B9"}
            borderRadius={4}
          >
            <Grid
              container
              justifyContent="left"
              alignItems="center"
              spacing={2}
            >
              <Grid item xs={3} mb={1}>
                <TextField
                  fullWidth
                  size={size}
                  margin="normal"
                  placeholder="..."
                  style={style}
                  focused
                  color="primary"
                  required
                  name="nro_serie"
                  label="N° Serie"
                  variant="outlined"
                  value={datosRegulador.nro_serie}
                  inputProps={{
                    maxLength: 60,
                  }}
                  onChange={almacenar}
                />
              </Grid>
              <Grid item xs={3}>
                <Autocomplete
                  fullWidth
                  focused
                  size="small"
                  disableClearable
                  options={marca}
                  noOptionsText="Marca INEXISTENTE"
                  getOptionLabel={(option) => option.descripcion_marca || ""}
                  isOptionEqualToValue={(option, value) =>
                    option.id_marca === value.id_marca
                  }
                  value={marcaSeleccionada}
                  onChange={(event, newValue) => {
                    setMarcaSeleccionada(newValue);
                    setDatosRegulador((prev) => ({
                      ...prev,
                      marca: newValue ? newValue.id_marca : null,
                    }));
                  }}
                  renderInput={(params) => (
                    <TextField
                      focused
                      style={style}
                      required
                      label="Marca"
                      variant="outlined"
                      {...params}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <Autocomplete
                  fullWidth
                  focused
                  size="small"
                  disableClearable
                  options={modelo}
                  noOptionsText="Modelo INEXISTENTE"
                  getOptionLabel={(option) => option.descripcion_modelos || ""}
                  isOptionEqualToValue={(option, value) =>
                    option.id_modelo === value.descripcion_modelos
                  }
                  value={modeloSeleccionado}
                  onChange={(event, newValue) => {
                    setModeloSeleccionado(newValue);
                    setDatosRegulador((prev) => ({
                      ...prev,
                      modelo: newValue ? newValue.id_modelo : null,
                    }));
                  }}
                  renderInput={(params) => (
                    <TextField
                      focused
                      style={style}
                      required
                      label="Modelo"
                      variant="outlined"
                      {...params}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={1.5} mb={1}>
                <TextField
                  fullWidth
                  size={size}
                  margin="normal"
                  placeholder="..."
                  style={style}
                  focused
                  color="primary"
                  required
                  name="año_fabricacion"
                  label="Año Fabricación"
                  variant="outlined"
                  value={datosRegulador.año_fabricacion}
                  inputProps={{
                    maxLength: 4,
                  }}
                  onChange={almacenar}
                />
              </Grid>
              <Grid item xs={1.5}>
                <FormControl style={style} focused>
                  <InputLabel>Estado</InputLabel>
                  <Select
                    fullWidth
                    label="Estado"
                    required
                    size="small"
                    name="estado"
                    value={datosRegulador.estado}
                    onChange={almacenar}
                    inputProps={{ "aria-label": "Without label" }}
                  >
                    {estado
                      ? estado.map((elemento) => (
                          <MenuItem key={elemento.id} value={elemento.id}>
                            {elemento.valor}
                          </MenuItem>
                        ))
                      : null}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={3}>
                <Autocomplete
                  fullWidth
                  size="small"
                  focused
                  disableClearable
                  options={presionEntrada || []} // Lista de opciones de la API
                  noOptionsText={"Presión de entrada INEXISTENTE"}
                  getOptionLabel={(option) => option.descripcion_presion || ""} // Cómo mostrar las opciones
                  isOptionEqualToValue={(option, value) =>
                    option.id_presion === value.descripcion_presion
                  } // Comparar valores
                  value={
                    presionEntrada?.find(
                      (item) =>
                        item.id_presion === datosRegulador.presion_entrada
                    ) || null
                  } // Mostrar valor seleccionado
                  onChange={(event, newValue) => {
                    setPresionEntradaSeleccionada(newValue);
                    setDatosRegulador((prev) => ({
                      ...prev,
                      presion_entrada: newValue ? newValue.id_presion : null,
                    }));
                  }}
                  renderInput={(params) => (
                    <TextField
                      style={style}
                      required
                      focused
                      {...params}
                      label="Presión Entrada"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <Autocomplete
                  fullWidth
                  size="small"
                  focused
                  disableClearable
                  options={presionSalida || []} // Lista de opciones de la API
                  noOptionsText={"Presión de salida INEXISTENTE"}
                  getOptionLabel={(option) => option.descripcion_presion || ""} // Cómo mostrar las opciones
                  isOptionEqualToValue={(option, value) =>
                    option.id_presion === value.descripcion_presion
                  } // Comparar valores
                  value={
                    presionSalida?.find(
                      (item) =>
                        item.id_presion === datosRegulador.presion_salida
                    ) || null
                  } // Mostrar valor seleccionado
                  onChange={(event, newValue) => {
                    setPresionSalidaSeleccionada(newValue);
                    setDatosRegulador((prev) => ({
                      ...prev,
                      presion_salida: newValue ? newValue.id_presion : null,
                    }));
                  }}
                  renderInput={(params) => (
                    <TextField
                      style={style}
                      required
                      focused
                      {...params}
                      label="Presión Salida"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <Autocomplete
                  fullWidth
                  size="small"
                  focused
                  disableClearable
                  options={caudal || []} // Lista de opciones de la API
                  noOptionsText={"Caudal INEXISTENTE"}
                  getOptionLabel={(option) => option.descripcion_caudal || ""} // Cómo mostrar las opciones
                  isOptionEqualToValue={(option, value) =>
                    option.id_caudal === value.descripcion_caudal
                  } // Comparar valores
                  value={
                    caudal?.find(
                      (item) => item.id_caudal === datosRegulador.caudal
                    ) || null
                  } // Mostrar valor seleccionado
                  onChange={(event, newValue) => {
                    setCaudalSeleccionado(newValue);
                    setDatosRegulador((prev) => ({
                      ...prev,
                      caudal: newValue ? newValue.id_caudal : null,
                    }));
                  }}
                  renderInput={(params) => (
                    <TextField
                      style={style}
                      required
                      focused
                      {...params}
                      label="Caudal"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <Autocomplete
                  fullWidth
                  size="small"
                  focused
                  disableClearable
                  options={sucursal || []} // Lista de opciones de la API
                  noOptionsText={"Sucursal INEXISTENTE"}
                  getOptionLabel={(option) => option.nombre || ""} // Cómo mostrar las opciones
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.nombre
                  } // Comparar valores
                  value={
                    sucursal?.find(
                      (item) => item.id === datosRegulador.sucursal
                    ) || null
                  } // Mostrar valor seleccionado
                  onChange={(event, newValue) => {
                    setSucursalSeleccionada(newValue);
                    setDatosRegulador((prev) => ({
                      ...prev,
                      sucursal: newValue ? newValue.id : null,
                    }));
                  }}
                  renderInput={(params) => (
                    <TextField
                      style={style}
                      required
                      focused
                      {...params}
                      label="Sucursal"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
            </Grid>

            <Grid
              container
              justifyContent="space-between"
              alignItems="flex-end"
              mt={2}
            >
              <Button variant="contained" onClick={handleClose} color="error">
                Volver
              </Button>

              <Button
                disabled={disBtn}
                variant="contained"
                type="submit"
                color="success"
              >
                Guardar Edición
              </Button>
            </Grid>
          </Box>
        </form>
      </Container>
      {notificacion ? (
        <Notify
          mensaje={mensaje}
          open={openSnack}
          color={colormensaje}
          finalizar={setFinalizar}
          severity={severitySnack}
        />
      ) : null}
      {/* ALERT --> SE MUESTRA SI HAY UN ERROR EN LA API (NO SE CONECTA O ESTÁ MAL LA RUTA, ETC.) */}
      {error && mensajeAlerta ? (
        <Alerta mensaje={mensajeAlerta} severity={severityAlerta} />
      ) : null}
    </div>
  );
}

export default EditarReg;
